import { Container, Heading } from '@chakra-ui/react';
import React from 'react';

import AllMembers from './AllMembers';

const MembersTab = () => (
  <Container
    as="section"
    maxW="container.xl"
    w="100%"
    pt={{ xs: '30px', sm: '50px', md: '68px' }}
    pb="100px"
  >
    <Heading
      as="h2"
      color="text.textBlue"
      fontSize={{ xs: '24px', sm: '30px' }}
      fontWeight="700"
      mb="15px"
    >
      Funds
    </Heading>
    <AllMembers collectionKey="members" />
    <Heading
      as="h2"
      mt="65px"
      color="text.textBlue"
      fontSize={{ xs: '24px', sm: '30px' }}
      fontWeight="700"
      mb="15px"
    >
      Knowledge Partners
    </Heading>
    <AllMembers collectionKey="knowledge_partner" />
  </Container>
);

export default MembersTab;
